import {Injectable, Injector} from '@angular/core';
import {CanActivate} from '@angular/router';
import AuthDataProvider from "./dataProviders/authDataProvider.service";
import * as jssha from 'jssha';
import {Observable} from "rxjs/Rx";
import IUser from "../interfaces/IUser";
import CypherService from "./cypher.service";
import {Router} from '@angular/router';
import * as _ from 'lodash';
import AuthService from "./auth.service";

@Injectable()
class LoginService implements CanActivate {
    constructor(private injector: Injector,
                private authService: AuthService) {

    }


    public canActivate(): boolean {
        const isLoggedIn: boolean = this.authService.isLocalLoggedIn();
        if (isLoggedIn) {
            this.injector.get(Router).navigate(['/measurements']);
        }
        return !isLoggedIn;
    }


}

export default LoginService;






// WEBPACK FOOTER //
// ./src/app/services/login.service.ts